/**
 * Primary (global) 
 * NOTE: This is written as an ES module
 */

// import utilities
/// <reference name="utils" path="./utils.js" />
window.utils = utils;

// dynamic import of ESModule (async)
import('./addTwo.mjs').then(({
  addTwo
}) => {
  //console.log("loaded external script.", { addTwo });
  //console.log(addTwo(4));
}).catch(error => 'An error occurred while loading the component');
;

// dynamic import of ESModule (async)
//import { addTwo } from './scripts/addTwo.mjs';
//const { } = await import('./scripts/addTwo.mjs');

//console.log("I'm the new master (JS)!");

// test helpers from ProvidePlugin
//console.log("is sitefinity editor? ", utils.isSitefinityEditor());